export const CONSENT_CHANGED_EVENT = 'le-consent-changed'

export function notifyConsentChanged() {
  window.dispatchEvent(new Event(CONSENT_CHANGED_EVENT))
}
